import {createRouter, createWebHistory,createWebHashHistory} from "vue-router";

const routes = [
    // 云课堂首页
    {
        path: "/",
        name: "Index",
        component: () =>
            import(/* webpackChunkName: "index" */ "../views/ocs/Index.vue"),
    },
    // 云课堂我的视频
    {
        path: "/myCourses",
        name: "MyCourses",
        component: () =>
          import(/* webpackChunkName: "index" */ "../views/ocs/MyCourses.vue"),
    },
    // 云课堂视频播放
    {
        path: "/course/:videoId",
        name: "CourseOld",
        component: () =>
          import(/* webpackChunkName: "index" */ "../views/ocs/Course.vue"),
    },
    // 云课堂视频播放 适配移动端路径
    {
        path: "/pages/coursePlay/coursePlay",
        name: "CourseOld2",
        component: () =>
            import(/* webpackChunkName: "index" */ "../views/ocs/Course.vue"),
    },
    // 云课堂视频播放
    {
        path: "/pages/courseDetails/courseDetails",
        name: "Course",
        component: () =>
            import(/* webpackChunkName: "index" */ "../views/ocs/Course.vue"),
    },
    // 云课堂专家列表
    {
        path: "/specialist",
        name: "Specialist",
        component: () =>
            import(/* webpackChunkName: "index" */ "../views/ocs/Specialist.vue"),
    },
    // 云课堂搜索
    {
        path: "/search/:keywords?",
        name: "search",
        component: () =>
          import(/* webpackChunkName: "index" */ "../views/ocs/Search.vue"),
    },
    // 订单信息
    {
        path: "/pages/orderPay/orderPay",
        name: "orderform",
        component: () =>
            import(/* webpackChunkName: "orderform" */ "../views/ocs/OrderForm.vue"),
    },
];
// createWebHashHistory(),
// createWebHistory(process.env.BASE_URL),
const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
